import { ArticlesCollectionProps } from '../types';

export const getLinkAttrsFromCollection = (
  collection: ArticlesCollectionProps
) => ({
  label: collection.title,
  href: `#${collection.hashLabel}`,
  id: collection.hashLabel,
});
